import styled, { css } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledIntentBanner = styled.div<{ isFullWidth: boolean }>`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    border-radius: 8px;
    border: 1px solid ${colorsPalettes.carbon["50"]};
    background: ${colorsPalettes.blue["100"]};
    padding: 24px;
    ${({ isFullWidth }) => {
        return css`
            width: ${isFullWidth ? "100%" : "initial"};
        `;
    }}
`;

export const StyledIntentIcon = styled.div`
    display: flex;
    align-items: center;
    margin-right: 16px;
`;

export const StyledIntentBannerContent = styled.div<{ isVerticalView: boolean }>`
    display: flex;
    flex-direction: column;
    ${({ isVerticalView }) => {
        return css`
            margin-right: ${isVerticalView ? "0" : "24px"};
            justify-content: ${isVerticalView ? "flex-start" : "center"};
        `;
    }}
`;

export const StyledIntentTitle = styled.div`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["500"])};
    margin-bottom: 3px;
`;

export const StyledIntentDescription = styled.div`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["500"])};
`;

export const StyledIntentButtonWrapper = styled.div<{ isVerticalView: boolean }>`
    display: flex;
    align-items: center;
    min-width: fit-content;
    ${({ isVerticalView }) => {
        return css`
            margin-left: ${isVerticalView ? "40px" : "0"};
        `;
    }}
`;

export const StyledIntentContentWrapper = styled.div<{ isVerticalView: boolean }>`
    display: flex;
    width: 100%;
    ${({ isVerticalView }) => {
        return css`
            flex-direction: ${isVerticalView ? "column" : "row"};
            justify-content: ${isVerticalView ? "flex-start" : "space-between"};
        `;
    }}
`;

export const StyledIntentContentWithIcon = styled.div<{ isVerticalView: boolean }>`
    display: flex;
    flex-direction: row;
`;
